import * as Yup from 'yup';

export default Yup.object({
  username: Yup.string().nullable().required('Username is required'),
  password: Yup.string().nullable().required('Password is required'),
});
